import React from 'react';
import PropTypes from 'prop-types';
import { compose, withHandlers, withState } from 'recompose';
import { connect } from 'react-redux';
import { SubmissionError } from 'redux-form';

import mapDispatchPropsToActions from 'store/helpers/mapDispatchToActions';
import { unsubscribe } from 'store/user/actions';
import { withPageViewTracking } from 'components/core/library/tracking-utils';
import { H1, Paragraph } from 'components/core/Typography';
import { UnsubscribeForm } from 'components/contact/UnsubscribeForm';

import './unsubscribePage.scss';
import { PAGE_TYPES } from '@sparefoot/tracking-events';

export const enhance = compose(
	connect(
		null,
		{ unsubscribe },
		mapDispatchPropsToActions
	),
	withPageViewTracking(PAGE_TYPES.UNSUBSCRIBE),
	withState('successMessage', 'setSuccessMessage', null),
	withHandlers({
		handleSubmit: (props) => (formData) =>
			props.actions.unsubscribe(formData).then(({ error, payload }) => {
				if (error) {
					throw new SubmissionError({ _error: error.message });
				} else {
					props.setSuccessMessage(payload.message);
				}
			}),
	})
);

export function UnsubscribePage({ handleSubmit, successMessage }) {
	return (
		<div className="unsubscribe-page">
			<div className="section-content">
				<H1 size="large">Unsubscribe from SpareFoot mailings</H1>
				<Paragraph>
					Enter your email address and click Unsubscribe to stop
					receiving email from SpareFoot.
				</Paragraph>
				{!successMessage && (
					<UnsubscribeForm
						onSubmit={handleSubmit}
					/>
				)}
				{!!successMessage && (
					<Paragraph className="success-message">
						<span
							dangerouslySetInnerHTML={{
								// eslint-disable-line react/no-danger
								__html: successMessage,
							}}
						/>
					</Paragraph>
				)}
			</div>
		</div>
	);
}

UnsubscribePage.propTypes = {
	handleSubmit: PropTypes.func.isRequired,
	successMessage: PropTypes.string,
};

export default enhance(UnsubscribePage);
